import { Injectable } from '@angular/core';
import { TokenService } from 'src/app/services/service_partagé/token.service';
import {environment} from '../../../environments/environment';
import Pusher from 'pusher-js';

@Injectable({
  providedIn: 'root'
})
export class PusherService {
  private pusher: any;

  // tslint:disable-next-line:no-shadowed-variable
  constructor(private TokenService: TokenService) {
    this.initializePusher();
  }

  private initializePusher() {
    this.pusher = new Pusher(environment.PUSHER_APP_KEY, {
      cluster: environment.PUSHER_APP_CLUSTER,
      channelAuthorization: {
        transport: 'ajax',
        endpoint: environment.API_URL + '/broadcasting/auth',
        // A provider, not a fixed header block: this service is created at
        // bootstrap, before anyone has logged in, and login navigates through
        // the router rather than reloading the page. Baking the token in at
        // construction meant every private channel authorised with whatever
        // was in storage at startup — usually nothing.
        headersProvider: () => ({
          Authorization: 'Bearer ' + this.TokenService.getToken(),
          Accept: 'application/json'
        })
      }
    });
  }

  public subscribe(channelName: string) {
    return this.pusher.subscribe(channelName);
  }

  public unsubscribe(channelName: string) {
    this.pusher.unsubscribe(channelName);
  }

  public disconnect() {
    this.pusher.disconnect();
  }
}
